import SiteShell from "../components/SiteShell";

function renderParagraphWithLinks(paragraph) {
  if (typeof paragraph !== "string") {
    return paragraph;
  }

  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  const parts = paragraph.split(urlRegex);

  return parts.map((part, index) => {
    if (!part) return null;
    const isUrl = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/.test(part);
    if (!isUrl) return part;

    const href = part.startsWith("www.") ? `https://${part}` : part;
    return (
      <a
        key={`${part}-${index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-sky-700 underline hover:text-sky-800"
      >
        {part}
      </a>
    );
  });
}

function PolicyLayout({ title, intro, lastUpdated, sections }) {
  const policyHighlights = [
    { label: "Processing Speed", value: "Real-time" },
    { label: "Target Audience", value: "Salaried" },
    { label: "Security Level", value: "Level 4" },
    { label: "Uptime Guaranteed", value: "99.99%" },
  ];

  return (
    <SiteShell route="company" heroHidden={true} highlightsHidden={true}>
      <section className="relative overflow-hidden bg-[#061a2e] pb-16 pt-24 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_10%,rgba(223,31,45,0.3),transparent_35%),radial-gradient(circle_at_100%_90%,rgba(18,169,191,0.2),transparent_35%)]" />
        <div className="relative z-10 mx-auto max-w-[1280px] px-6 md:px-10">
          <p className="inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-1 text-[10px] font-black uppercase tracking-[0.3em] text-sky-200">
            Policies
          </p>
          <h1 className="mt-7 text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
            {title}
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/75 md:text-lg">
            {intro}
          </p>
          <p className="mt-5 text-xs font-bold uppercase tracking-[0.2em] text-sky-100/60">
            Last updated: {lastUpdated}
          </p>
        </div>
      </section>

      <section className="relative z-20 mx-auto -mt-8 max-w-[1280px] px-6 md:px-10">
        <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-[0_20px_50px_-12px_rgba(10,44,79,0.12)] backdrop-blur-2xl md:grid-cols-4 lg:p-6">
          {policyHighlights.map((item) => (
            <article
              key={item.label}
              className="group relative rounded-2xl bg-slate-50/50 p-6 transition-all hover:bg-white hover:shadow-xl"
            >
              <div className="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-[#e37921] opacity-0 transition-opacity group-hover:opacity-100" />
              <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]/80">
                {item.label}
              </p>
              <h3 className="mt-2 text-xl font-extrabold tracking-tight text-[#0a2c4f]">
                {item.value}
              </h3>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto mt-8 max-w-[1280px] px-6 pb-24 md:px-10">
        <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.18)] md:p-10">
          <div className="space-y-8">
            {sections.map((section) => (
              <article
                key={section.heading}
                className="rounded-2xl border border-slate-100 bg-slate-50/70 p-5 md:p-6"
              >
                <h2 className="text-2xl font-bold tracking-tight text-[#0a2c4f]">
                  {section.heading}
                </h2>
                <div className="mt-4 space-y-4 text-sm leading-relaxed text-slate-700 md:text-base">
                  {(section.paragraphs || []).map((paragraph, index) => (
                    <p key={`${section.heading}-p-${index}`}>
                      {renderParagraphWithLinks(paragraph)}
                    </p>
                  ))}
                  {section.items ? (
                    <ul className="list-disc space-y-2 pl-5">
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default PolicyLayout;
